angular.module('natgeo').factory('Analytics', 
function Analytics()
{
  var Analytics = {};

  Analytics.CATEGORY = 'RoboWorks';
  
  Analytics.ACTION_START = 'Start';
  Analytics.ACTION_COMPLETE = 'Complete';

  Analytics.start = function(levelName)
  {
    if ( window.ga )
    {
      window.ga('send', 'event', Analytics.CATEGORY, Analytics.ACTION_START, levelName);    
    }
  };

  Analytics.complete = function(levelName)
  {
    if ( window.ga )
    {
      window.ga('send', 'event', Analytics.CATEGORY, Analytics.ACTION_COMPLETE, levelName);    
    }
  };

  return Analytics;
});